import { emptySelection } from "../../constants";
/**
 * Map selections according to given ordering
 * @param order
 * @param selections
 */
export const mapSelections = (selections, order) => order.map(type => selections.length && selections.find(s => s.outcomeType === type) || emptySelection);
//# sourceMappingURL=mapSelections.js.map